import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'FilterPipe',
  pure: false
})
export class FilterPipePipe implements PipeTransform {

  transform(items: any[], value: string): any[] {
    if (!items) { return []; }
      return items.filter(it => it.toLowerCase().includes(value ? value.toLowerCase() : ''));
    /*return items.filter(it => it[field].toLowerCase().includes(value ? value.toLowerCase() : ''));*/

  }

}



// WEBPACK FOOTER //
// ./src/app/pages/import-template/component/concat/filter-pipe.pipe.ts